import { computed, defineComponent, reactive } from "vue";
import { useRouter } from "vue-router";
import { store } from "./store/PasswordReissueStore";
import { MsgBox } from "~/components/MsgBox";
import { Log, Validator, presence, email } from "~/extensions/utils";
import Loading from 'quasar/src/plugins/loading/Loading.js';
import { commonStore } from "~/store/CommonStore";
import { MailAddress } from "~/api/data/MailAddress";
const log = Log.create("PasswordReissueEntryPage");
const constraints = computed(() => ({
    mailAddress: {
        presence: presence(false, commonStore.messages.PV0001),
        email: email({ message: commonStore.messages.PV0013 })
    }
}));
export default defineComponent({
    name: "PasswordReissueEntryPage",
    beforeRouteEnter(to, from, next) {
        store.clear();
        next();
    },
    setup() {
        const data = reactive(new MailAddress());
        const valid = reactive(new Validator(data, constraints.value));
        const router = useRouter();
        const submit = async () => {
            valid.reset();
            if (valid.error || !data.mailAddress) {
                MsgBox.error(commonStore.messages.PV0017);
                return;
            }
            try {
                Loading.show();
                await store.passwordReissue(data);
                router.push({ name: "password-reissue-check" });
            }
            catch (ex) {
                if (!valid.handle(ex)) {
                    log.error("PasswordReissueEntryPage", ex);
                    await MsgBox.error(ex.message);
                    if (ex.message.includes("こちらのページから行うことができません。")) {
                        router.push({ name: "login" });
                    }
                }
            }
            finally {
                Loading.hide();
            }
        };
        return {
            data,
            valid,
            submit
        };
    }
});
